module.exports = "<span class=\"tag tag-pill c-pill c-pill--active c-pill--{{theme}}\" [class.c-pill--active]=\"selectedPill == pill\" (click)=\"toggle(pill)\" *ngFor=\"let pill of pills\">\n\t<span *ngIf=\"isIcon\">\n\t\t<i class=\"icon__n icon__n--{{ pill.icon }}\"></i>\n\t</span>\n<span *ngIf=\"!isIcon\">\n\t\t{{ pill.text }} \n\t</span>\n\n<span class=\"tag tag-pill c-pill__bagde\" *ngIf=\"pill.count\">{{pill.count}}</span>\n</span>"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common-module/components/pill-group/pill-group.component.html
// module id = ./src/app/modules/common-module/components/pill-group/pill-group.component.html
// module chunks = 9